import {Component, ElementRef, OnInit, TemplateRef, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NbDialogService, NbToastrService} from '@nebular/theme';
import {NbThemeModule} from '@nebular/theme';
import {ActivatedRoute, Router, Params} from '@angular/router';
import {LocalDataSource} from 'ng2-smart-table';
import {MainService} from '../../../../services/main.service';
import { EstadisticasComponent } from 'src/app/public/biodiversidad/estadisticas/estadisticas.component';
@Component({
  selector: 'app-editar-formulario',
  templateUrl: './editar-formulario.component.html',
  styleUrls: ['./editar-formulario.component.scss']
})
export class EditarFormularioComponent implements OnInit {
  @ViewChild('dialog', {static: true}) dialog: ElementRef;

  frmFormulario: FormGroup;
  loading = false;
  ocultarOpciones= false;
  submitted = false;
  idSeccion= 0;
  idFrm: any;
  newSeccion= '';
  pregunta = ''; // Define la pregunta
  tipo = ''; // Define seccion a la cual pertenecera la pregunta si es multiple o unica
  seccion = ''; // Define seccion a la cual pertenecera la pregunta
  opciones = 0; //Define la cantidad de opciones posible a la respuesta
  bloquearCheckbox = '';
  //pregunta= [];
  preguntas= [];
  secciones= [];
  muestraMultiple = false;
  muestraGeografica= false;
  posiblesOpciones= [];
  formulario = {
    nombre:'',
    descripcion: '',
    estado: ''
  };
  resp:any = [{res:''}];
  respMultiple:any = [{opcion:'',res:false}];
  respGeografica:any = [{opcion:'',tipo:''}];
  listaSeccion: any[];
  //nuevos elementos
  preguntaSeccion= '';
  tipoPreguntaSeccion= '';
  opcionesSeccion= '';
  loadingPrincipal=false;
  constructor(private toastrService: NbToastrService,
    public router: Router,
    private dialogService: NbDialogService,
    private rutaActiva: ActivatedRoute,
    public mainService: MainService,
    public fb: FormBuilder) { 
      this.idFrm = this.rutaActiva.snapshot.params.id;
      this.frmFormulario = this.fb.group({
        nombre:[''],
        descripcion:[''],
        estado: ['']
    });

    }

  ngOnInit() {
    this.getFormulario(this.idFrm);
    //this.getSecciones();
  }
  get valoresCrear() {
    return this.frmFormulario.controls;
  }
  onChange(deviceValue) {
    console.log(deviceValue);
    switch(deviceValue) {
      case "Multiple":
        this.muestraMultiple = true;
        break;
      case "Unica":
        this.muestraMultiple = true;
        break;
        case "Geografica":
          this.muestraGeografica = true;
          break;
      default:
        this.respMultiple = [{opcion:'',res:false,valor: ''}];
        this.respGeografica = [{opcion:'',tipo:''}];
        this.muestraMultiple = false;
        this.muestraGeografica = false;
    }
}
  getFormulario(id) {
    this.loadingPrincipal = true;       

    this.mainService.get('newFormulario/'+id).subscribe(result => {
      if (result) {
        this.formulario.nombre = result.nombre,
        this.formulario.descripcion = result.descripcion;
        this.formulario.estado = result.estado;
        this.preguntas = JSON.parse(result.preguntas);
        console.log(this.preguntas)
        if(this.preguntas !== null){
          this.secciones=this.preguntas;
        }
        this.loadingPrincipal = false;       

      } else {
        this.loadingPrincipal = false;       
        console.log("Error al insertar en Sql");
      }
    })
}
agregarSeccion() {
  let secciones = {
      seccion: this.newSeccion,
      preguntas:[]
  }
  console.log(secciones)
  this.secciones.push(secciones)
  this.newSeccion= "";

  /*this.mainService.post('newSeccion', insert).subscribe(result => {
      console.log(result);
      if (result) {
          console.log('Se ha insertado');
          //this.spinner.hide();
          this.showToast('top-right', 'success', 'Success!', 'It was created successfully!');
          this.getSecciones();
          return true;
      } else {
          console.log('Error');
          this.showToast('top-right', 'warning', 'Error!', 'Error creating!');
          this.getSecciones();
          return false;
      }
  });*/
}
AgregarOpcion(){
  let respuesta = {
    opcion: '',
    res: false,
    valor: '',
}
this.respMultiple.push(respuesta)
}
AgregarOpcionRespuesta(idS, idPr){
  let respuesta = {
    opcion: '',
    res: false,
    valor: '',
}
console.log(idS +"-"+idPr+"-")
console.log(this.preguntas[idS].preguntas[idPr].respuestas)
this.preguntas[idS].preguntas[idPr].respuestas.push(respuesta)
}
getSecciones(){
  this.mainService.get('newSeccion').subscribe(value => {
    console.log(value);
    this.listaSeccion = value;
  })
}
deleteSeccion(idpos){
  this.secciones.splice( idpos, 1 );

 /* console.log(insert)
  this.mainService.put('newSeccion/'+idsec, insert).subscribe(result => {
      console.log(result);
      if (result) {
          console.log('Se ha insertado');
          this.showToast('top-right', 'success', 'Success!', 'Se ha Editado con exito');
          this.getSecciones();
          return true;
      } else {
          console.log('Error');
          this.loading = false;
          this.showToast('top-right', 'warning', 'Error!', 'Error!');
          this.getSecciones();
          return false;
      }
  });*/
}
deletePregunta(idposSeccion, idPregunta){
  this.secciones[idposSeccion].preguntas.splice( idPregunta, 1 );
}/*
cambiarTipo(tipo){
  if(tipo === 'Unica'){
    this.callType(1);
    this.ocultarOpciones= true;
  }else{
    this.ocultarOpciones= false;
  }
}
*/
/*
callType(typeEmp){
  console.log(typeEmp);
  this.posiblesOpciones=[];
  for (let i = 0; i < typeEmp; i++) {
    let insert = {
      opcion: '',
      valor: '',
      disable: '',
    }
    this.posiblesOpciones.push(insert);
  }
  console.log(this.posiblesOpciones)
}*/
/*
cantResp(typeEmp, pos){
  console.log(typeEmp);
  console.log(pos);
  this.preguntas[pos].opciones=[];
  for (let i = 0; i < typeEmp; i++) {
    let insert = {
      opcion: '',
      correcta: false,
      disable: '',
    }
    this.preguntas[pos].opciones.push(insert);
  }
 }
 */
 /*
 check(id){
  if(this.tipo === 'Unica' && this.posiblesOpciones[id].correcta === false){
   for (let i = 0; i < this.opciones; i++) {
        if(this.posiblesOpciones[i] === this.posiblesOpciones[id]){
          this.posiblesOpciones[id].disable = !this.posiblesOpciones[id].correcta
        }else{
          this.posiblesOpciones[i].disable = false
        }
    }
    console.log(this.posiblesOpciones)
  }else{
    for (let i = 0; i < this.opciones; i++) {
        this.posiblesOpciones[i].disable = ''
    }
    console.log(this.posiblesOpciones)
  }
}
*/
/*
checkAux(id, idP){
  console.log(this.preguntas)
  console.log(this.preguntas[idP].opciones.length)
  if(this.preguntas[idP].tipo === 'Unica' && this.preguntas[idP].opciones[id].correcta === false){
   for (let i = 0; i < this.preguntas[idP].opciones.length; i++) {
    if(this.preguntas[idP].opciones[i] === this.preguntas[idP].opciones[id]){
      this.preguntas[idP].opciones[i].disable = !this.preguntas[idP].opciones[id].correcta
    }else{
      this.preguntas[idP].opciones[i].disable = false
    }
    }
    console.log(this.preguntas)
  }else{
    for (let i = 0; i < this.preguntas[idP].opciones.length; i++) {
      this.preguntas[idP].opciones[i].disable = '';
    }
    console.log(this.preguntas)
  }
}
*/
/*
borrarOpcion(id){
  this.posiblesOpciones.splice(id, 1);
  console.log(this.opciones)
  this.opciones= this.opciones - 1; 
}*/
borrarPregunta(id){
  this.preguntas.splice(id, 1);
}
deleteOpcion(id){
  if(id !== 0){
    this.respMultiple.splice(id, 1);
  }
}
deleteOpcionRespuesta(posSec, posPregunta, posRes){
  console.log(posSec)
  console.log(posPregunta)
  console.log(posRes)

  console.log(this.preguntas[posSec].preguntas[posPregunta].respuestas[posRes])
    this.preguntas[posSec].preguntas[posPregunta].respuestas.splice(posRes, 1);
}
agregarPreguntaSeccion(id) { //usado
  this.respMultiple = [{opcion:'',res:false}];
  this.preguntaSeccion= '';
  this.tipoPreguntaSeccion= '';
  this.muestraMultiple = false;
  console.log(id)
  this.idSeccion= id;
  this.openDialogSave(this.dialog);
}

openDialogSave(dialog) { //usada
  this.dialogService.open(dialog, { context: 'this is some additional data passed to dialog' });
}
save(){ //usada
  this.loadingPrincipal = true;
  if(this.secciones.length === 0){
    this.showToast('top-right', 'warning', 'No se ha agregado ninguna pregunta!', 'Error!');
    return false
  }
  this.loading= true;
  let usu = this.frmFormulario.value;
  let insert = {
  nombre: usu.nombre,
  descripcion: usu.descripcion,
  estado: usu.estado,
  preguntas: JSON.stringify(this.secciones)
  }
  console.log(insert)
  this.mainService.put('newFormulario/'+this.idFrm, insert).subscribe(result => {
      console.log(result);
      if (result) {
        this.loadingPrincipal = false;
          console.log('Se ha insertado');
          this.showToast('top-right', 'success', 'Success!', 'Se ha Guardado con exito');
          return true;
      } else {
          console.log('Error');
          this.loadingPrincipal = false;
          this.loading = false;
          this.showToast('top-right', 'warning', 'Error!', 'Error!');
          return false;
      }
  });
}
onGoTo() { //usada
  this.router.navigate(["dashboard/crear-formularios"]);
}
agregarPregunta(){ //usada
   if( this.pregunta === ''){
    this.showToast('top-right', 'warning', 'La pregunta no deben ir vacia!', 'Error!');
    return false;
   }
  
  console.log(this.posiblesOpciones)
  let insert = {
    pregunta: this.pregunta,
    tipo: this.tipo,
    seccion: this.seccion,
    opciones: this.posiblesOpciones,
    cantOpciones: this.opciones
  }
  this.preguntas.push(insert);
  this.pregunta = '';
  this.tipo = '';
  this.seccion = '';
  this.opciones = 0;
  this.posiblesOpciones= [];
  console.log(this.preguntas);
  this.ocultarOpciones= false;
}
guardarPregunta(){ //usada
  if(this.tipoPreguntaSeccion === 'Multiple' || this.tipoPreguntaSeccion === 'Unica'){
    let insert = {
      pregunta: this.preguntaSeccion,
      tipo: this.tipoPreguntaSeccion,
      respuestas: this.respMultiple
    }
    this.secciones[this.idSeccion].preguntas.push(insert);
    console.log(this.secciones);
    let element: HTMLElement = document.getElementById('btn-close-save') as HTMLElement;
    element.click();
    this.preguntaSeccion="";
    this.tipoPreguntaSeccion="";
    this.muestraMultiple = false;
    this.respMultiple = [{opcion:'',res:false}];

  }else if(this.tipoPreguntaSeccion === 'Geografica'){
    let insert = {
      pregunta: this.preguntaSeccion,
      tipo: this.tipoPreguntaSeccion,
      respuestas: this.respGeografica
    }
    this.secciones[this.idSeccion].preguntas.push(insert);
    console.log(this.secciones);
    let element: HTMLElement = document.getElementById('btn-close-save') as HTMLElement;
    element.click();
    this.preguntaSeccion="";
    this.tipoPreguntaSeccion="";
    this.muestraGeografica = false;
    this.respGeografica = [{opcion:'',tipo:''}];
  }
  else{
    let insert = {
      pregunta: this.preguntaSeccion,
      tipo: this.tipoPreguntaSeccion,
      respuestas: this.resp
    }
    this.secciones[this.idSeccion].preguntas.push(insert);
    console.log(this.secciones);
    let element: HTMLElement = document.getElementById('btn-close-save') as HTMLElement;
    element.click();
    this.preguntaSeccion="";
    this.tipoPreguntaSeccion="";
    this.muestraMultiple = false;
    this.muestraGeografica = false;
  }
  
}
showToast(position, status, titulo, mensaje) { //usada
  this.toastrService.show(mensaje, titulo, { position, status });
}
}
